import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import moment from 'moment';
import ItemRow from '@components/ActionsCommon/ItemRows';
const DialogsViewDetail = (props) => {
  const { userInfo, openView, setOpenView, refetch } = props;
  const handleClose = () => {
    setOpenView(false);
  };
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openView}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Chi tiết người dùng</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <ItemRow title="Tên đăng nhập:" value={userInfo?.user_name} />
            {/* <ItemRow title="Email:" value={userInfo?.email || '-'} />
            <ItemRow title="Số điện thoại:" value={userInfo?.phone || '-'} /> */}
            <ItemRow
              title="Vai trò:"
              value={userInfo?.roleDetails?.map((r) => r.name).join(', ') || '-'}
            />
            <ItemRow
              title="Tài khoản công ty:"
              value={userInfo?.is_company_user ? 'Có' : 'Không'}
            />
            {!userInfo?.is_company_user && (
              <>
                <ItemRow
                  title="Chi nhánh:"
                  value={
                    userInfo?.branch_names?.length > 0 ? userInfo.branch_names.join(', ') : '-'
                  }
                />
                <ItemRow
                  title="Tổ quản lý:"
                  value={userInfo?.group_names?.length > 0 ? userInfo.group_names.join(', ') : '-'}
                />
              </>
            )}
            <ItemRow
              title="Trạng thái:"
              value={userInfo?.is_active ? 'Hoạt động' : 'Ngừng hoạt động'}
            />
            <ItemRow
              title="Thời gian tạo:"
              value={moment(userInfo?.created_at).format('DD-MM-YYYY HH:mm')}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogsViewDetail;
